import type React from 'react';
import type { ResolvedPhoneShell } from 'magical-trails';

import { isHexColour, readableAs, readableOn } from './colour';

/**
 * The story's own colours, laid over the look's, as CSS variables for any
 * element carrying `data-ph-theme`. `--ph-on-accent` is worked out here
 * rather than left to the author, so the text on an accent button always has
 * the contrast to be read whatever accent they pick.
 */
export function phoneStyleVars(
  shell: ResolvedPhoneShell,
  viewportHeight?: number | null
): React.CSSProperties {
  const vars: Record<string, string> = {};
  const { accent, wallpaper } = shell.colours;
  if (isHexColour(accent)) {
    vars['--ph-accent'] = accent;
    const on = readableOn(accent);
    if (on) vars['--ph-on-accent'] = on;
    const asText = readableAs(accent, shell.themeSpec.screen);
    if (asText) vars['--ph-accent-text'] = asText;
  }
  if (isHexColour(wallpaper)) vars['--ph-wallpaper-tint'] = wallpaper;
  // The on-screen keyboard shrinks the VISUAL viewport only; a fixed,
  // full-height layout would leave the composer underneath it.
  if (viewportHeight) vars['--ph-viewport-height'] = `${viewportHeight}px`;
  return vars as React.CSSProperties;
}
